import { createSelector } from '@reduxjs/toolkit';
import { SHORT_FORM_WEB } from 'shared/common/constants/abExperiments';

import { TObjectType, TRealEstateType } from '../../types';
import { selectEntityId } from './selectEntityId';
import { selectFormDefaults } from './selectFormDefaults';
import { selectProgramsVersion } from './selectProgramsVersion';
import { selectRealEstateType } from './selectRealEstateType';
import { selectRegionId } from './selectRegionId';
import { selectShortFormGroup } from './selectShortFormGroup';

/* Тело запроса собирают две независимые ветки: useSaveOffers и useShortFormAuthAction */
export const selectSaveOffersParams = createSelector(
  [
    selectProgramsVersion,
    selectRegionId,
    selectRealEstateType,
    selectEntityId,
    selectFormDefaults,
    selectShortFormGroup,
  ],
  (programsVersion, regionId, realEstateType, entityId, formData, shortFormGroup) => ({
    programsVersion,
    /* Группу считают и фронт, и бэк: без явной передачи они расходятся молча, и человек
       из одной группы уезжает по ссылке другой */
    ...(shortFormGroup ? { experiments: { [SHORT_FORM_WEB]: shortFormGroup } } : {}),
    searchParams: {
      regionId,
      realEstate: {
        type: realEstateType as TRealEstateType,
        id: realEstateType === 'newBuilding' ? entityId : 0,
      },
      objectType: formData.objectType as TObjectType,
      objectCost: formData.objectCost,
      downPayment: formData.downPayment,
      loanTermYears: formData.loanTermYears,
    },
  }),
);
